import { type Step } from "../../components/Stepper/Stepper";
import {
  faBullhorn,
  faChartBar,
  faDice,
  faEnvelope,
  faGear,
  faGift,
  faPalette
} from "@fortawesome/free-solid-svg-icons";
import Brush from "../../components/Icons/Brush";
import GiftIcon from "../../components/Icons/Gift";
import DiceIcon from "../../components/Icons/DiceIcon";
import CTAIcon from "../../components/Icons/CTAIcon";
import MailIcon from "../../components/Icons/MailIcon";
import BullHorn from "../../components/Icons/BullHorn";
import { tt } from "../../utils/i18n/i18n";
import Gear from "../../components/Icons/Gear";

export const STEP_0 = -1;
export const STEP_1_LOGO_COLORS: number = 0;
export const STEP_2_GIFTS: number = 1;
export const STEP_3_GAMES: number = 2;
export const STEP_4_CTAS: number = 3;
export const STEP_5_MKTG_AUTO: number = 4;
export const STEP_6_POSA: number = 5;
export const STEP_7_SETTINGS: number = 7;
export const STEP_8: number = 7;

export const MAX_STEP = STEP_7_SETTINGS;

export const jetpackDashboardSteps: Step[] = [
  {
    title: tt("saas_game_configuration_logo_and_colors_heading"),
    name: tt("saas_game_configuration_logo_and_colors_heading"),
    index: STEP_1_LOGO_COLORS,
    number: "1",
    icon: faPalette,
    svg: Brush(),
    pathName: "colors"
  },
  {
    title: tt("onboarding_choose_gifts_name"),
    name: tt("onboarding_choose_gifts_name"),
    index: STEP_2_GIFTS,
    number: "2",
    longTitle: tt("onboarding_choose_gifts_longtitle"),
    icon: faGift,
    svg: GiftIcon(),
    pathName: "prizes"
  },
  {
    title: tt("games_and_skins"),
    name: tt("games_and_skins"),
    index: STEP_3_GAMES,
    number: "3",
    longTitle: tt("onboarding_select_games_longtitle"),
    icon: faDice,
    svg: DiceIcon(),
    pathName: "games"
  },
  {
    title: tt("onboarding_choose_ctas_name"),
    name: tt("onboarding_choose_ctas_name"),
    index: STEP_4_CTAS,
    number: "4",
    longTitle: tt("onboarding_choose_ctas_longtitle"),
    icon: faChartBar,
    svg: CTAIcon(),
    pathName: "ctas"
  },
  {
    title: tt("onboarding_choose_emails_name"),
    name: tt("onboarding_choose_emails_name"),
    index: STEP_5_MKTG_AUTO,
    number: "5",
    longTitle: tt("onboarding_choose_emails_longtitle"),
    icon: faEnvelope,
    svg: MailIcon(),
    pathName: "marketing"
  },
  {
    title: tt("onboarding_choose_distribution_name"),
    name: tt("onboarding_choose_distribution_name"),
    index: STEP_6_POSA,
    number: "6",
    icon: faBullhorn,
    svg: BullHorn(),
    pathName: "distribution",
    noCheck: true
  },
  {
    title: tt("onboarding_settings"),
    name: tt("onboarding_settings"),
    index: STEP_7_SETTINGS,
    number: "7",
    icon: faGear,
    svg: Gear(),
    pathName: "settings",
    noCheck: true
  }
];
